import { useEffect, useState } from "react";

import Select from "react-select";

import { useAuth } from "@/components/lib/auth";
import { TimeslotCard } from "@/components/pages_logged_in/schedule/timeslots/TimeslotCard";
import {
  GetAllCoachProductsQuery,
  ProductCategories,
  useGetAllCoachProductsQuery,
} from "@/graphql";
import { SelectOption } from "@/types/select";

import { CalendarAccounts } from "./CalendarAccountSetting/CalendarAccounts";
import { CalendarSettingsWrapper } from "./CalendarSettings";
import { ScheduleSettings } from "./ScheduleSettings";

type CoachProduct =
  GetAllCoachProductsQuery["productsByCoachId"]["coachProducts"][number];

export function AvailabilityRelatedSettings() {
  const { currentUser } = useAuth();
  const [selectedProduct, setSelectedProduct] = useState<CoachProduct | null>(
    null,
  );
  const [showAllTimes, setShowAllTimes] = useState(false);

  const { data, loading } = useGetAllCoachProductsQuery({
    variables: {
      coachId: currentUser.id,
      categories: [ProductCategories.Meeting],
    },
    skip: !currentUser.isAgent,
  });

  const specialties = data?.productsByCoachId.specialties || [];
  const products = specialties.flatMap((specialty) =>
    specialty.products.filter((p) => !p.introProduct),
  );
  const coachProducts = data?.productsByCoachId.coachProducts || [];

  useEffect(() => {
    if (!selectedProduct && products.length > 0) {
      setSelectedProduct(coachProducts[0]);
    }
  }, [products]);

  const productOptions: SelectOption[] = products.map((p) => ({
    value: p.id,
    label: p.name,
  }));

  const triggerRefetch = () => {
    setSelectedProduct(null);
  };

  return (
    <>
      <CalendarAccounts onSettingChanged={() => triggerRefetch()} />
      <ScheduleSettings onSettingChanged={() => triggerRefetch()} />
      <CalendarSettingsWrapper onSettingChanged={() => triggerRefetch()} />

      <div className="w-full rounded-lg border border-gray-300 bg-white p-6 shadow-sm mt-6">
        <div className="flex justify-between items-start">
          <div className="flex flex-col">
            <div className="text-2xl font-bold">Preview Your Availability</div>
            <div className="text-sm text-gray-500 mb-4">
              Below is your live availability based on the above settings
            </div>
          </div>
          {/* Product */}
          <div className="flex flex-col mr-8">
            <div className="flex items-center">
              <Select
                isLoading={loading}
                value={productOptions.find(
                  (o) => o.value === selectedProduct?.productId,
                )}
                onChange={(option) => {
                  const product = products.find((p) => p.id === option?.value);
                  if (product) {
                    setSelectedProduct(
                      coachProducts.find(
                        (coachProduct) => coachProduct.productId === product.id,
                      ) || null,
                    );
                  }
                }}
                isSearchable={true}
                options={productOptions}
                className="text-sm font-normal"
              />
            </div>
          </div>
        </div>

        <TimeslotCard
          coachId={currentUser.id}
          productId={selectedProduct?.productId || undefined}
          requiresBookingApproval={false}
          onSelectTimeslots={() => {}}
          selectedTimeslots={[]}
          isViewOnly={true}
          showAllTimes={showAllTimes}
          setShowAllTimes={setShowAllTimes}
          variant="side-by-side"
          preferredTimeslots={[]}
          onPreferredChange={() => {}}
        />
      </div>
    </>
  );
}
